window.addEventListener('DOMContentLoaded', function () {
  const Swiper = window.Swiper;
  const carousel = document.querySelector('.columns-carousel');

  if (carousel) {
    new Swiper('.columns-carousel', {
      slidesPerView: 1,
      spaceBetween: 20,
      centerInsufficientSlides: true,
      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1080: {
          slidesPerView: 3,
          spaceBetween: 80,
        },
      },
      navigation: {
        nextEl: '.columns-carousel__navigation .swiper-button-next',
        prevEl: '.columns-carousel__navigation .swiper-button-prev',
      },
      pagination: {
        el: '.columns-carousel__navigation .swiper-pagination',
        clickable: true,
      },
    });
  }
});
